import {
  Address,
  FloorsList,
  MembersList,
  MembersListInfo,
  PropertiesList,
  PropertiesListInfo,
  Property,
  PropertyAction as Action,
  PropertyActionTypes as ActionTypes,
  RoomsList,
  SelectUser,
  SelectMembersListInfo,
  TenantsList,
  TenantsListInfo,
  Information,
  ContractsList,
  ContractsListInfo,
  Contract,
  PropertyUser,
  TenantItem,
  Approver,
  ApproverListInfo,
  SelectApproverListInfo,
} from './types';

export const init = (): Action => ({ type: ActionTypes.INIT });

export const refresh = (): Action => ({ type: ActionTypes.REFRESH });

export const refresh2 = (): Action => ({ type: ActionTypes.REFRESH2 });

export const setIsLoading = (isLoading: boolean): Action => ({
  type: ActionTypes.LOADING,
  payload: isLoading,
});

export const setIsLoading2 = (isLoading2: boolean): Action => ({
  type: ActionTypes.LOADING2,
  payload: isLoading2,
});

export const setIsLoading3 = (isLoading3: boolean): Action => ({
  type: ActionTypes.LOADING3,
  payload: isLoading3,
});

export const setIsSubmitting = (isSubmitting: boolean): Action => ({
  type: ActionTypes.SUBMITTING,
  payload: isSubmitting,
});

export const setIsNavigating = (isNavigating: boolean): Action => ({
  type: ActionTypes.NAVIGATING,
  payload: isNavigating,
});

export const setIsNavigatingTo = (isNavigatingTo: number | null): Action => ({
  type: ActionTypes.NAVIGATING_TO,
  payload: isNavigatingTo,
});

export const setIsNeedConfirm = (isNeedConfirm: boolean): Action => ({
  type: ActionTypes.NEED_CONFIRM,
  payload: isNeedConfirm,
});

export const setProperties = (properties: PropertiesList[]): Action => ({
  type: ActionTypes.SET_PROPERTIES,
  payload: properties,
});

export const setPropertiesListInfo = (info: PropertiesListInfo | null): Action => ({
  type: ActionTypes.SET_PROPERTIES_LIST_INFO,
  payload: info,
});

export const setProperty = (property: Property | null): Action => ({
  type: ActionTypes.SET_PROPERTY,
  payload: property,
});

export const setFloors = (floors: FloorsList[]): Action => ({
  type: ActionTypes.SET_FLOORS,
  payload: floors,
});

export const setRooms = (rooms: RoomsList[]): Action => ({
  type: ActionTypes.SET_ROOMS,
  payload: rooms,
});

export const setMembers = (members: MembersList[]): Action => ({
  type: ActionTypes.SET_MEMBERS,
  payload: members,
});

export const setMembersListInfo = (info: MembersListInfo | null): Action => ({
  type: ActionTypes.SET_MEMBERS_LIST_INFO,
  payload: info,
});

export const setSelectMembers = (selectMembers: SelectUser[]): Action => ({
  type: ActionTypes.SET_SELECT_MEMBERS,
  payload: selectMembers,
});

export const setSelectMembersListInfo = (info: SelectMembersListInfo | null): Action => ({
  type: ActionTypes.SET_SELECT_MEMBERS_LIST_INFO,
  payload: info,
});

/**
 * @summary 査収・承認者設定に関連する取得APIのLoading状態を保持する
 * @param {boolean} isLoadingApprover Loading中か
 * @returns {Action}
 */
export const setIsLoadingApprover = (isLoadingApprover: boolean): Action => ({
  type: ActionTypes.LOADING_APPROVER,
  payload: isLoadingApprover,
});

/**
 * @summary 全建物管理者への査収・承認許可設定を保持する
 * @param {boolean} canApproveAllManager 全建物管理者への査収・承認許可設定
 * @returns {Action}
 */
export const setCanApproveAllManager = (canApproveAllManager: boolean): Action => ({
  type: ActionTypes.SET_CAN_APPROVE_ALL_MANAGER,
  payload: canApproveAllManager,
});

/**
 * @summary 建物詳細 査収・承認タブで使用する査収・承認者の一覧を保持する
 * @param {Approver[]} members 査収・承認者の一覧
 * @returns {Action}
 */
export const setApprovers = (members: Approver[]): Action => ({
  type: ActionTypes.SET_APPROVERS,
  payload: members,
});

/**
 * @summary 建物詳細 査収・承認タブで使用する査収・承認者の一覧のページャ情報を保持する
 * @param {ApproverListInfo | null} info ページャ情報
 * @returns {Action}
 */
export const setApproverListInfo = (info: ApproverListInfo | null): Action => ({
  type: ActionTypes.SET_APPROVER_LIST_INFO,
  payload: info,
});

/**
 * @summary 査収・承認者以外の建物担当者一覧を保持する
 * @param {SelectUser[]} selectApprovers 査収・承認者以外の建物担当者一覧
 * @returns {Action}
 */
export const setSelectApprovers = (selectApprovers: SelectUser[]): Action => ({
  type: ActionTypes.SET_SELECT_APPROVERS,
  payload: selectApprovers,
});

/**
 * @summary 査収・承認者以外の建物担当者一覧のページャ情報を保持する
 * @param {SelectApproverListInfo | null} info ページャ情報
 * @returns {Action}
 */
export const setSelectApproverListInfo = (info: SelectApproverListInfo | null): Action => ({
  type: ActionTypes.SET_SELECT_APPROVER_LIST_INFO,
  payload: info,
});

/**
 * @summary 建物に設定されている全ての査収・承認者を保持する
 * @param {Approver[]} allApprovers 建物に設定されている全ての査収・承認者
 * @returns {Action}
 */
export const setAllApprovers = (allApprovers: Approver[]): Action => ({
  type: ActionTypes.SET_ALL_APPROVERS,
  payload: allApprovers,
});

export const setTenants = (tenants: TenantsList[]): Action => ({
  type: ActionTypes.SET_TENANTS,
  payload: tenants,
});

export const setTenantsListInfo = (info: TenantsListInfo | null): Action => ({
  type: ActionTypes.SET_TENANTS_LIST_INFO,
  payload: info,
});

/**
 * @summary 建物に紐づくテナントデータ（全件）を保持する
 * @param {TenantItem[]} tenantItemList テナントデータ
 * @returns {Action}
 */
export const setTenantItemsList = (tenantItemList: TenantItem[]): Action => ({
  type: ActionTypes.SET_TENANT_ITEM_LIST,
  payload: tenantItemList,
});

export const setAddressAutofill = (data: Address | null): Action => ({
  type: ActionTypes.SET_ADDRESS_AUTOFILL,
  payload: data,
});

export const setInformation = (information: Information | null): Action => ({
  type: ActionTypes.SET_INFORMATION,
  payload: information,
});

export const setContracts = (contracts: ContractsList[]): Action => ({
  type: ActionTypes.SET_CONTRACTS,
  payload: contracts,
});

export const setContractsListInfo = (info: ContractsListInfo | null): Action => ({
  type: ActionTypes.SET_CONTRACTS_LIST_INFO,
  payload: info,
});

export const setContract = (contract: Contract | null): Action => ({
  type: ActionTypes.SET_CONTRACT,
  payload: contract,
});

/**
 * @summary 建物担当者（ページャなし）を保持
 * @param {PropertyUser[]} propertyUserList
 * @returns {Action}
 */
export const setPropertyUserList = (propertyUserList: PropertyUser[]): Action => ({
  type: ActionTypes.SET_PROPERTY_USER_LIST,
  payload: propertyUserList,
});

/**
 * @summary 計算した関連ドキュメント(ローカルファイル)のファイルサイズ合計を設定する
 * @param documentFileSize 計算した関連ドキュメント(ローカルファイル)のファイルサイズ合計
 */
export const setDocumentFileSize = (documentFileSize: number): Action => ({
  type: ActionTypes.SET_DOCUMENT_FILE_SIZE,
  payload: documentFileSize,
});
